module.exports = __webpack_public_path__ + "static/img/9.82be1b51.png";